import(/* webpackMode: "eager" */ "/src/src/app/[variants]/_lens-components/style/client.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/frame-process/ClientPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
